module.exports = __webpack_public_path__ + "img/leftlogin.d33be789.png";